import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './styles/App.css';
import Header from './components/Header';
import SearchSection from './components/SearchSection';
import ItemTypeSection from './components/ItemTypeSection';
import NewArrivalsMarquee from './components/NewArrivalsMarquee';
import NewArrivalsPage from './components/NewArrivalsPage';
import BookDetail from './components/BookDetail';
import AdvancedSearch from './components/AdvancedSearch';
import DiscoverySection from './components/DiscoverySection';
import ExamEssentialsShelf from './components/ExamEssentialsShelf';
import LibraryConstellation from './components/LibraryConstellation';
import SubjectDirectoryPage from './components/SubjectDirectoryPage';
import SubjectExplorerPage from './components/SubjectExplorerPage';
import LibraryInsightsPage from './components/LibraryInsightsPage';
import FacultyShowcasePage from './components/FacultyShowcasePage';
import NotFoundPage from './components/NotFoundPage';
import Footer from './components/Footer';
import { getThemeKey, THEME_CLASS_NAMES } from './services/themeSchedule';
import DDCBrowserPage from './components/DDCBrowserPage';

function AppContent() {
  const location = useLocation();
  const [showUpButton, setShowUpButton] = useState(false);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname]);

  // Subtle automatic theme shift based on time of day / exam windows (see services/themeSchedule).
  useEffect(() => {
    document.body.classList.remove(...THEME_CLASS_NAMES);
    document.body.classList.add(getThemeKey());
  }, []);

  // Setup keyboard shortcut for search
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        const searchInput = document.getElementById('searchInput');
        if (searchInput) {
          searchInput.focus();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setShowUpButton(window.scrollY > 280);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <div className="container">
          <Routes>
            <Route path="/" element={
              <>
                <SearchSection />
                <ItemTypeSection />
                <ExamEssentialsShelf />
                <NewArrivalsMarquee />
                <DiscoverySection />
                {/* <ImageCarousel /> */}
                {/* <QuickActions /> */}
                {/* <FeaturedSection /> */}
              </>
            } />
            <Route path="/book/:biblioId" element={<BookDetail />} />
            <Route path="/new-arrivals-month-wise" element={<NewArrivalsPage />} />
            <Route path="/advanced-search" element={<AdvancedSearch />} />
            <Route path="/subjects" element={<SubjectDirectoryPage />} />
            <Route path="/collection-map" element={<LibraryConstellation />} />
            <Route path="/subjects/:subjectKey" element={<SubjectExplorerPage />} />
            <Route path="/insights" element={<LibraryInsightsPage />} />
            <Route path="/faculty-showcase" element={<FacultyShowcasePage />} />
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/discover" element={<DDCBrowserPage />} />
            <Route path="/discover/:range" element={<DDCBrowserPage />} />
          </Routes>
        </div>
      </main>
      {showUpButton && (
        <button
          type="button"
          className="scroll-up-btn"
          onClick={handleScrollToTop}
          aria-label="Scroll to top"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="18 15 12 9 6 15"/></svg>
        </button>
      )}
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
